import { createContext, useContext, useEffect, useState } from "react";

const CartContext = createContext(null);
const KEY = "jx_cart";

export function CartProvider({ children }) {
  const [items, setItems] = useState(() => {
    try {
      return JSON.parse(localStorage.getItem(KEY)) || [];
    } catch {
      return [];
    }
  });

  useEffect(() => {
    localStorage.setItem(KEY, JSON.stringify(items));
  }, [items]);

  const add = (l) =>
    setItems((prev) =>
      prev.some((x) => x.id === l.id)
        ? prev
        : [...prev, { id: l.id, title: l.title, price: l.price, file_type: l.file_type, seller_id: l.seller_id, seller: l.seller?.name }]
    );
  const remove = (id) => setItems((prev) => prev.filter((x) => x.id !== id));
  const clear = () => setItems([]);
  const has = (id) => items.some((x) => x.id === id);
  const total = items.reduce((s, x) => s + Number(x.price || 0), 0);

  return (
    <CartContext.Provider value={{ items, add, remove, clear, has, total, count: items.length }}>
      {children}
    </CartContext.Provider>
  );
}

export const useCart = () => useContext(CartContext);
